module.exports = __webpack_public_path__ + "static/media/showHistory.3d1ba29a.svg";